/**
 * 	in format 10/20/2003 16:24:20 -- This format will cause timezone problem
 *  in format '2022-10-03T19:28:04.449Z'
 * @param d 
 * @returns 
 */
export function DateTimeToText(d: Date) {
    try {
        return `${d.getFullYear()}-${d.getMonth() < 9 ? '0':''}${d.getMonth() + 1}-${d.getDate() < 10 ? '0':''}${d.getDate()}` + " "
            + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    } catch (e) {
        return "";
    }
}

/**
 * in format 10/20/2003 16:24:20 -- This format will cause timezone problem
 * in format '2022-10-03T19:28:04.449Z'
 * @param d 
 * @returns 
 */
export function DateToText(d: Date) {
    try {
        return `${d.getFullYear()}-${d.getMonth() < 9 ? '0':''}${d.getMonth() + 1}-${d.getDate() < 10 ? '0':''}${d.getDate()}`;
    } catch (e) {
        return "";
    }
}